const NotificationState = {
  emails: [],
  sms: [],
  ads: [],
  messages: [],
  chatAvatar: ""
};

export default NotificationState;
